export const GET_SHOP_CATEGORY_PRODUCT_BY_COMPANY_ID =
  "GET_SHOP_CATEGORY_PRODUCT_BY_COMPANY_ID";
export const GET_SHOP_CATEGORY_PRODUCT_BY_COMPANY_ID_SUCCES =
  "GET_SHOP_CATEGORY_PRODUCT_BY_COMPANY_ID_SUCCES";
export const GET_SHOP_CATEGORY_PRODUCT_BY_COMPANY_ID_FAILED =
  "GET_SHOP_CATEGORY_PRODUCT_BY_COMPANY_ID_FAILED";
